module.exports = __webpack_public_path__ + "static/media/service_guranteed_img.71861652.svg";